import { INQUIRY_ASSIGN_MEMBER_MESSAGES } from 'shared'

type AssignMemberNotice = {
  message: string
  variant: 'default' | 'warning' | 'error'
}

type AssignMemberNoticeState = {
  /** 候補の人数。取得前・取得失敗は undefined */
  candidateCount: number | undefined
  isError: boolean
}

/**
 * アサイン候補の取得状態から、メンバー欄の下に出す案内を決める。
 *
 * 候補が0人なのはフィールドの状態なので、リスト内（検索0件）ではなくフィールド下に警告として出す。
 * 取得失敗は、リストが TBA/TBD だけになり「候補がいない」と読めてしまうため、0人（warning）とは別に error で出す。
 * 取得前（undefined かつ isError でない）は、開いた瞬間に警告が出ないよう通常の案内にする。
 * 再取得に失敗しても前回の候補が残っているとき（candidateCount が数値）は、失敗とみなさない。
 */
export function resolveAssignMemberNotice({ candidateCount, isError }: AssignMemberNoticeState): AssignMemberNotice {
  if (isError && candidateCount === undefined) {
    return { message: INQUIRY_ASSIGN_MEMBER_MESSAGES.FETCH_FAILED, variant: 'error' }
  }
  if (candidateCount === 0) {
    return { message: INQUIRY_ASSIGN_MEMBER_MESSAGES.NO_ASSIGNABLE_MEMBERS, variant: 'warning' }
  }
  return { message: INQUIRY_ASSIGN_MEMBER_MESSAGES.CANDIDATE_SCOPE, variant: 'default' }
}
